<template>
  <nav id="sidebar" class="sidebar">
    <a class="sidebar-brand" href="">
      <logo height="50" type="light" />
    </a>
    <div class="sidebar-content">
      <div class="sidebar-user">
        <img
          :src="user.picture"
          class="img-fluid rounded-circle mb-2"
          alt="profile"
        />
        <div class="fw-bold">{{ user.name }}</div>
        <!-- <small>Front-end Developer</small> -->
      </div>

      <ul class="sidebar-nav">
        <li class="sidebar-header">Main</li>
        <li class="sidebar-item">
          <router-link class="sidebar-link" :to="{ name: 'writer' }">
            <i class="align-middle me-2 fas fa-fw fa-home"></i>
            <span class="align-middle">Dashboard</span>
          </router-link>
        </li>
        <li class="sidebar-header">Management</li>
        <li class="sidebar-item">
          <router-link class="sidebar-link" :to="{ name: 'writer.orders' }">
            <i class="align-middle me-2 fas fa-fw fa-pencil"></i>
            <span class="align-middle">Assigned Orders</span>
          </router-link>
        </li>
        <li class="sidebar-header">Account</li>
        <li class="sidebar-item">
          <a class="sidebar-link" href="#" @click.prevent="logout">
            <i class="align-middle me-2 fas fa-fw fa-sign-out"></i>
            <span class="align-middle">Log Out</span>
          </a>
        </li>
        <li class="sidebar-item" v-if="1 == 0">
          <a
            data-bs-target="#dashboards"
            data-bs-toggle="collapse"
            class="sidebar-link collapsed"
          >
            <i class="align-middle me-2 fas fa-fw fa-list"></i>
            <span class="align-middle">Menu</span>
          </a>
          <ul
            id="dashboards"
            class="sidebar-dropdown list-unstyled collapse"
            data-bs-parent="#sidebar"
          >
            <li class="sidebar-item">
              <a class="sidebar-link" href="dashboard-default.htm">Default</a>
            </li>
            <li class="sidebar-item">
              <a class="sidebar-link" href="dashboard-analytics.htm"
                >Analytics</a
              >
            </li>
            <li class="sidebar-item">
              <a class="sidebar-link" href="dashboard-e-commerce.htm"
                >E-commerce</a
              >
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      
    }
  },

  methods: {
    logout() {
      this.$axios.post('/api/v1/logout').then(() => {
        this.$storage.remove('token')
        window.location.href = this.$router.resolve({ name: 'login' }).href
      })
    }
  },

  computed: {
    user() {
      return this.$store.getters.getAuthUser
    }
  }
};
</script>
